export function isDefined<T>(value: T | undefined | null): value is T {
  return value !== undefined && value !== null;
}

export function isDefinedString(value: string | undefined | null) {
  return isDefined(value) && value.length > 0;
}

export const isDigit = (n: any): boolean => +n == n;
